import { jsxs as M, jsx as l } from "react/jsx-runtime";
import { useField as N } from "formik";
import { isString as S } from "lodash-es";
import g, { useState as A, useRef as T, useCallback as I, useEffect as U } from "react";
import W from "react-input-mask";
import { useDebounce as Y } from "react-use";
import { I as q } from "../../constants-C9JADvZj.mjs";
import { getMasking as z } from "./helpers.js";
import { Wrapper as G, Label as J, Input as K, ErrorLabel as O, HintLabel as Q, LinkLabel as X } from "./styled.js";
const ie = g.forwardRef(function({
  delay: k = q,
  name: r,
  label: v = "",
  ariaLabel: E = "",
  type: R = "text",
  disabled: $ = !1,
  placeholder: x = "",
  as: V = "Normal",
  maskingOptions: i,
  linkText: h,
  hint: p,
  maxLength: j = 100,
  children: w,
  labelProps: y,
  errorLabelProps: n,
  ...B
}, a) {
  const [u, c, b] = N(r), [D, f] = A(""), o = T(), m = c.touched && c.error;
  let s, d;
  const { value: t, onBlur: C } = u, _ = I(
    (e) => {
      e.preventDefault(), S(t) && b.setValue(t.trim()), C(e);
    },
    [t, b, C]
  );
  Y(
    () => {
      o.current && u.onChange(o.current);
    },
    k,
    [o.current]
  ), U(() => {
    f(t || "");
  }, [t]);
  const F = I((e) => {
    e.persist();
    const L = e.currentTarget.value;
    f(L), o.current = e;
  }, []);
  if (i)
    s = i.mask, d = i.formatChars;
  else {
    const e = z(t, V);
    e && (s = e.mask, d = e.formatChars);
  }
  const H = g.useCallback(
    (e) => {
      typeof a == "object" && a !== null ? a.current = e : typeof a == "function" && a(e);
    },
    [a]
  );
  return /* @__PURE__ */ M(G, { children: [
    /* @__PURE__ */ l(J, { htmlFor: r, id: `${r}.label`, ...y, children: v }),
    /* @__PURE__ */ l(
      K,
      {
        ...B,
        as: W,
        inputRef: H,
        name: u.name,
        "aria-label": E,
        value: D,
        onChange: F,
        onBlur: _,
        type: R,
        disabled: $,
        placeholder: x,
        maxLength: s ? void 0 : j,
        mask: s ?? "",
        maskChar: "",
        formatChars: d,
        "aria-invalid": !!m,
        "aria-labelledby": `${r}.label`,
        ...m ? { "aria-errormessage": (n == null ? void 0 : n.id) ?? `${r}.errorlabel` } : {}
      }
    ),
    w,
    m && /* @__PURE__ */ l(O, { id: `${r}.errorlabel`, ...n, children: c.error }),
    p && /* @__PURE__ */ l(Q, { children: p }),
    h && /* @__PURE__ */ l(X, { as: "button", children: h })
  ] });
});
export {
  ie as Input,
  ie as default
};
